import { render, staticRenderFns } from "./LeftAreaItem.vue?vue&type=template&id=4b0b49a1&scoped=true"
import script from "./LeftAreaItem.vue?vue&type=script&lang=js"
export * from "./LeftAreaItem.vue?vue&type=script&lang=js"
import style0 from "./LeftAreaItem.vue?vue&type=style&index=0&id=4b0b49a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b49a1",
  null
  
)

export default component.exports